import { ShipmentLeadTimeRepository } from 'app/modules/settings/domain/repository/ShipmentLeadTimeRepository';
import { AxiosTencerAdminApiClient } from 'app/shared/infrastructure/api/AxiosTencerAdminApiClient';
import { ShipmentLeadTimeArray } from 'app/modules/settings/domain/entity/ShipmentLeadTimeArray';
import { ShipmentLeadTimeArrayMapper } from 'app/modules/settings/infrastructure/repository/api/dataMapper/ShipmentLeadTimeArrayMapper';

export class ApiShipmentLeadTimeRepository implements ShipmentLeadTimeRepository {

    constructor(private _apiClient: AxiosTencerAdminApiClient) {}

    public async findAll(): Promise<ShipmentLeadTimeArray> {
        const response = await this._apiClient.getShipmentLeadTimes();
        return ShipmentLeadTimeArrayMapper.toDomain(response.data);
    }

    public async update(id: string, leadDays: number): Promise<void> {
        await this._apiClient.updateShipmentLeadTime(id, { lead_days: leadDays });
    }

}
